import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/shopComment/page', data, {
    trim: true
  })
}
export function updateById (data) {
  return request.post('/business/shopComment/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/shopComment/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/shopComment/delete/batch', {
    params: {
      ids
    }
  })
}
